import React, { useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Paper,
  Typography,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { usePost } from "../../../../hooks/usePost";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setRefresh } from "../../../../redux/refreshSlice";

const ConvertUnitRelationForm = ({ unitRelationData }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      fromUnitQty: "",
      toUnitQty: "",
      relatedFromUnitStockBatch: "",
      relatedToUnitStockBatch: "",
      createNewToUnitStockBatch: false,
    },
  });

  const { postData, loading: postLoading } = usePost(`convert-unit `);
  const { id } = useParams();
  const { refresh } = useSelector((state) => state.refresh);
  const { selectedBranch } = useSelector((state) => state.filterItemUnit);

  const dispatch = useDispatch();
  const handleConvert = async (data) => {
    const payload = {
      ...data,
      relatedItem: id,
      relatedFromUnit: unitRelationData?.isInverted
        ? unitRelationData.relatedToUnit._id
        : unitRelationData.relatedFromUnit._id,
      relatedToUnit: unitRelationData?.isInverted
        ? unitRelationData.relatedFromUnit._id
        : unitRelationData.relatedToUnit._id,
      relatedUnitRelation: unitRelationData._id,
      isRelationInverted: unitRelationData?.isInverted ? true : false,
      relatedBranch: selectedBranch,
      relatedFromUnitInfo:
        unitRelationData?.relatedFromUnit?.relatedFromUnitInfo?._id,
      relatedToUnitInfo:
        unitRelationData?.relatedToUnit?.relatedToUnitInfo?._id,
    };

    await postData(payload);
    dispatch(setRefresh(!refresh));
  };

  const fromQty = watch("fromUnitQty");
  const toQty = watch("toUnitQty");
  const relatedFromUnitStockBatch = watch("relatedFromUnitStockBatch");
  const createNewToUnitStockBatch = watch("createNewToUnitStockBatch");

  // Check if toUnitQty is not an integer (has decimal)
  const isToQtyDecimal = toQty && !Number.isInteger(parseFloat(toQty));
  // const selectedFromUnitStockBatch =
  //   unitRelationData?.relatedFromUnit?.relatedFromUnitStockBatch?.relatedStockBatches.find(
  //     (el) => el._id === relatedFromUnitStockBatch,
  //   );

  // const selectedToUnitStockBatch =
  //   unitRelationData?.relatedToUnit?.relatedToUnitStockBatch?.relatedStockBatches.find(
  //     (el) => el._id === relatedFromUnitStockBatch,
  //   );

  const selectedFromUnitStockBatch =
    unitRelationData?.relatedFromUnit?.relatedFromUnitInfo;

  console.log(selectedFromUnitStockBatch);

  const selectedToUnitStockBatch =
    unitRelationData?.relatedToUnit?.relatedToUnitInfo;

  console.log("selectedToUnitStockBatch", selectedToUnitStockBatch);
  useEffect(() => {
    // if (unitRelationData) {
    //   reset({
    //     fromUnitQty: 0,
    //     toUnitQty: 0,
    //   });
    // }

    if (unitRelationData?.isInverted) {
      // reset({
      //   fromUnitQty: unitRelationData.toUnitQty,
      //   toUnitQty: unitRelationData.fromUnitQty,
      // });
      setValue("fromUnitQty", unitRelationData.toUnitQty);
      setValue("toUnitQty", unitRelationData.fromUnitQty);
    } else {
      // reset({
      //   fromUnitQty: 0,
      //   toUnitQty: 0,
      // });
      setValue("fromUnitQty", 0);
      setValue("toUnitQty", 0);
    }

    if (fromQty > 0 && !unitRelationData?.isInverted) {
      // reset({
      //   fromUnitQty: fromQty,
      //   toUnitQty:
      //     fromQty * (unitRelationData.toUnitQty / unitRelationData.fromUnitQty),
      // });
      setValue("fromUnitQty", fromQty);

      setValue(
        "toUnitQty",
        fromQty * (unitRelationData.toUnitQty / unitRelationData.fromUnitQty),
      );
    } else if (fromQty > 0 && unitRelationData?.isInverted) {
      // reset({
      //   fromUnitQty: fromQty,
      //   toUnitQty:
      //     fromQty * (unitRelationData.fromUnitQty / unitRelationData.toUnitQty),
      // });
      setValue("fromUnitQty", fromQty);
      setValue(
        "toUnitQty",
        fromQty * (unitRelationData.fromUnitQty / unitRelationData.toUnitQty),
      );
    }
    //  else {
    //   reset({
    //     fromUnitQty: 0,
    //     toUnitQty: 0,
    //   });
    // }

    if (createNewToUnitStockBatch) {
      setValue("relatedToUnitStockBatch", "");
    }
  }, [unitRelationData, fromQty, createNewToUnitStockBatch]);

  useEffect(() => {
    if (
      unitRelationData?.relatedFromUnit?.relatedFromUnitInfo
        ?.relatedStockBatches?.length > 0 &&
      !unitRelationData.isInverted
    ) {
      setValue(
        "relatedFromUnitStockBatch",
        unitRelationData?.relatedFromUnit?.relatedFromUnitInfo
          ?.relatedStockBatches[0]._id,
      );
    } else if (
      unitRelationData?.relatedToUnit?.relatedToUnitInfo?.relatedStockBatches
        ?.length > 0 &&
      unitRelationData.isInverted
    ) {
      setValue(
        "relatedFromUnitStockBatch",
        unitRelationData?.relatedToUnit?.relatedToUnitInfo
          ?.relatedStockBatches[0]._id,
      );
    }
  }, [unitRelationData]);

  return (
    <>
      <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          Quantity Conversion
        </Typography>

        {unitRelationData && (
          <Box sx={{ mb: 2, p: 2, bgcolor: "grey.50", borderRadius: 1 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              <strong>Conversion Rule:</strong>
              {unitRelationData?.isInverted
                ? ` ${unitRelationData.toUnitQty} ${
                    unitRelationData.relatedToUnit?.name
                  } = ${unitRelationData.fromUnitQty} ${
                    unitRelationData.relatedFromUnit?.name
                  }`
                : ` ${unitRelationData.fromUnitQty} ${
                    unitRelationData.relatedFromUnit?.name
                  } = 
              ${unitRelationData.toUnitQty} 
              ${unitRelationData.relatedToUnit?.name}`}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Converting from:{" "}
              {!unitRelationData.isInverted && (
                <>
                  <strong>{unitRelationData.relatedFromUnit?.name}</strong> to:{" "}
                  <strong>{unitRelationData.relatedToUnit?.name}</strong>
                </>
              )}
              {unitRelationData.isInverted && (
                <>
                  <strong>{unitRelationData.relatedToUnit?.name}</strong> to:{" "}
                  <strong>{unitRelationData.relatedFromUnit?.name}</strong>
                </>
              )}
            </Typography>
          </Box>
        )}

        <Box component="form" onSubmit={handleSubmit(handleConvert)} noValidate>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3}>
              <Controller
                name="relatedFromUnitStockBatch"
                control={control}
                rules={{ required: "From Unit Stock batch is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="From Unit Stock Batch"
                    variant="outlined"
                    fullWidth
                    size="small"
                    disabled={postLoading}
                    error={!!errors.relatedFromUnitStockBatch}
                    helperText={errors.relatedFromUnitStockBatch?.message}
                  >
                    {!unitRelationData?.isInverted
                      ? unitRelationData?.relatedFromUnit?.relatedFromUnitInfo?.relatedStockBatches?.map(
                          (option) => (
                            <MenuItem key={option._id} value={option._id}>
                              {option.code}
                            </MenuItem>
                          ),
                        )
                      : unitRelationData?.relatedToUnit?.relatedToUnitInfo?.relatedStockBatches?.map(
                          (option) => (
                            <MenuItem key={option._id} value={option._id}>
                              {option.code}
                            </MenuItem>
                          ),
                        )}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Controller
                name="fromUnitQty"
                control={control}
                // rules={{
                //   required: "From quantity is required",
                //   validate: (value) => {
                //     const numValue = parseFloat(value);
                //     console.log(value,selectedFromUnitStockBatch?.qty,"validation")
                //     if (
                //       !unitRelationData?.isInverted &&
                //       relatedFromUnitStockBatch &&
                //       numValue > selectedFromUnitStockBatch?.qty
                //     ) {
                //       return (
                //         "Maximum quantity allowed is " +
                //         selectedFromUnitStockBatch?.qty +
                //         " units"
                //       );
                //     } else if (
                //       unitRelationData?.isInverted &&
                //       numValue > unitRelationData?.relatedToUnit?.qty
                //     ) {
                //       return (
                //         "Maximum quantity allowed is " +
                //         unitRelationData?.relatedToUnit?.qty +
                //         " units"
                //       );
                //     }

                //     return true;
                //   },
                // }}
                rules={{
                  required: "From quantity is required",
                  validate: (value) => {
                    const numValue = Number(value);

                    if (isNaN(numValue) || numValue <= 0) {
                      return "Enter valid quantity";
                    }

                    if (
                      !unitRelationData?.isInverted &&
                      selectedFromUnitStockBatch &&
                      numValue > Number(selectedFromUnitStockBatch?.qty)
                    ) {
                      return `Maximum quantity allowed is ${selectedFromUnitStockBatch?.qty} units`;
                    }

                    if (
                      unitRelationData?.isInverted &&
                      numValue > Number(unitRelationData?.relatedToUnit?.qty)
                    ) {
                      return `Maximum quantity allowed is ${unitRelationData?.relatedToUnit?.qty} units`;
                    }

                    return true;
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={`${unitRelationData?.isInverted ? unitRelationData.relatedToUnit?.name : unitRelationData.relatedFromUnit?.name} Quantity ( current qty : ${unitRelationData?.isInverted ? selectedToUnitStockBatch?.qty : relatedFromUnitStockBatch ? selectedFromUnitStockBatch?.qty : unitRelationData.relatedFromUnit?.qty} )`}
                    variant="outlined"
                    fullWidth
                    size="small"
                    type="number"
                    disabled={postLoading}
                    inputProps={{
                      min: "0",
                      step: "1",
                    }}
                    error={!!errors.fromUnitQty}
                    helperText={errors.fromUnitQty?.message}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Controller
                name="toUnitQty"
                control={control}
                rules={{ required: "To quantity is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={`${unitRelationData?.isInverted ? unitRelationData.relatedFromUnit?.name : unitRelationData.relatedToUnit?.name} Quantity ( current qty : ${unitRelationData?.isInverted ? selectedFromUnitStockBatch?.qty : selectedToUnitStockBatch?.qty} )`}
                    variant="outlined"
                    fullWidth
                    size="small"
                    type="number"
                    disabled
                    inputProps={{ min: "0" }}
                    error={!!errors.toUnitQty}
                    helperText={errors.toUnitQty?.message}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Controller
                name="relatedToUnitStockBatch"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="To Unit Stock Batch"
                    variant="outlined"
                    fullWidth
                    size="small"
                    disabled={postLoading || createNewToUnitStockBatch}
                    error={!!errors.relatedToUnitStockBatch}
                    helperText={errors.relatedToUnitStockBatch?.message}
                  >
                    {!unitRelationData?.isInverted
                      ? unitRelationData?.relatedToUnit?.relatedToUnitInfo?.relatedStockBatches?.map(
                          (option) => (
                            <MenuItem key={option._id} value={option._id}>
                              {option.code}
                            </MenuItem>
                          ),
                        )
                      : unitRelationData?.relatedFromUnit?.relatedFromUnitInfo?.relatedStockBatches?.map(
                          (option) => (
                            <MenuItem key={option._id} value={option._id}>
                              {option.code}
                            </MenuItem>
                          ),
                        )}
                  </TextField>
                )}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Controller
                name="createNewToUnitStockBatch"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={field.value || false}
                        disabled={postLoading}
                        color="primary"
                      />
                    }
                    label="Store New To Unit Stock"
                  />
                )}
              />
            </Grid>

            {unitRelationData?.isInverted && (
              <Grid item xs={12} sm={3}>
                <Controller
                  name="createInverted"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value || false}
                          disabled={postLoading}
                          color="primary"
                        />
                      }
                      label="Create Invert Relation"
                    />
                  )}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={3}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="medium"
                disabled={postLoading || isToQtyDecimal}
              >
                {postLoading
                  ? "Converting..."
                  : isToQtyDecimal
                    ? "Decimal not allowed"
                    : "Convert"}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
};

export default ConvertUnitRelationForm;
